// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__kBlLe","col":"Table_col__rYlee","fulfillmentStatus":"Table_fulfillmentStatus__1HmSi","emailCol":"Table_emailCol__17-VG"};